// API Base URL
import axios from "axios";
const $axios = axios.create({
  baseURL: (localStorage.getItem("apiPath") ||
    process.env.VUE_APP_API_SS_BASE_URL) as string | undefined,
});
export { $axios };
